import type { SolarSectionState } from "./solar-presentation-data"
import { Panel, Section } from "../BatteryOnlyProposal/primitives"

type SectionNoticeProps =
  | {
      id: string
      /** The section's read: loading or failed shows a notice, ready none. */
      state: Pick<SolarSectionState<unknown>, `status`>
      /** What the section shows: "Loading {noun}", "Unable to load {noun}". */
      noun: string
    }
  | { id: string; children: string }

const noticeText = (props: SectionNoticeProps): string | null => {
  if (`children` in props) {
    return props.children
  }
  switch (props.state.status) {
    case `error`:
      return `Unable to load ${props.noun}`
    case `loading`:
      return `Loading ${props.noun}`
    case `ready`:
      return null
  }
}

/** A section's own loading, error, or empty state, in place of its content. */
export const SectionNotice = (props: SectionNoticeProps): JSX.Element | null => {
  const text = noticeText(props)
  return text == null ? null : (
    <Section id={props.id}>
      <Panel className="px-6 py-10 text-center">
        <p
          role="status"
          className="text-[length:var(--step--1)] text-bp-text-muted"
        >
          {text}
        </p>
      </Panel>
    </Section>
  )
}
